export enum EIframeState {
  current = 0,
  next = 1,
}
